export default __webpack_public_path__ + "static/media/news106.8f400232.jpg";